import { render } from "./AttendTable.vue?vue&type=template&id=804d580c"
import script from "./AttendTable.vue?vue&type=script&lang=ts"
export * from "./AttendTable.vue?vue&type=script&lang=ts"
script.render = render

export default script